import { Card, CardContent, Typography, makeStyles } from "@material-ui/core";
import React, { useState } from "react";

import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import dayjs from "dayjs";
import { fetchApplicationHistory } from "../../../services/applicationsHistory";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import GovGrCard from "../../../components/GovGrCard";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
});
// const DarkerDisabledTextField = withStyles({
//   root: {
//     marginTop: 15,
//     marginBottom: 15,
//     "& .MuiInputBase-root.Mui-disabled": {
//       color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
//     },
//   },
// })(TextField);

const ApplicationHistory = React.memo(
  ({ setFieldValue, errors, touched, values, id }) => {
    const [error, setError] = useState("");
    const { t } = useLocale();
    const classes = useStyles();
    const { data, isError, isLoading, refetch } = useQuery(
      ["applicationHistoryWithId", id],
      () => fetchApplicationHistory(id)
    );

    return (
      <>
        <div className={classes.root}>
          <GovGrCard>
            <Typography variant="h3" color="textPrimary" gutterBottom>
              {t("Application History")}
            </Typography>
            <div>
              <CustomAlert
                open={isError}
                close={() => {
                  refetch();
                }}
                message={t("A network error occured, please try again later")}
              />

              <CustomTable
                options={{
                  showTitle: false,
                }}
                isLoading={isLoading}
                columns={[
                  {
                    title: t("From Status"),
                    field: "oldStatus",
                    render: (rowData) =>
                      rowData.oldStatus
                        ? rowData.oldStatus
                        : t("New application"),
                  },
                  {
                    title: t("To Status"),
                    field: "newStatus",
                  },
                  {
                    title: t("Modified Date"),
                    field: "modified_on",
                    render: (rowData) =>
                      dayjs(rowData.modified_on).format("DD/MM/YYYY HH:mm:ss"),
                  },
                  {
                    title: t("Comments"),
                    field: "comments",
                  },
                ]}
                data={data}
              />
            </div>
          </GovGrCard>
        </div>
      </>
    );
  }
);

export default ApplicationHistory;
